<div class="booking-container" *ngIf="!loader">
    <div class="heading_sert">
       <sm-title-bar pageTitle="Add New Tax" [backWithParams]="true">
       
       </sm-title-bar>
    </div>


    <div class="row">
       <!-- International tax start -->
       <div class="col-md-12" *ngIf="isEntityForeign == '1'">
          <mat-card appearance="outlined" class="booking-form">
          <div class="inter_set">
            
            <div>
               <mat-form-field appearance="outline">
                  <mat-label>Configuration name</mat-label>
                  <input matInput #input [(ngModel)]="intTaxObj.slab_name">
                 
               </mat-form-field>
            </div>
            <div>
               <mat-form-field appearance="outline">
                  <mat-label>Configuration description</mat-label>
                  <textarea matInput #input [(ngModel)]="intTaxObj.slab_desc"></textarea>
                 
               </mat-form-field>
            </div> 
          
          
           
          <form [formGroup]="taxValueform">
           <div formArrayName="values">
              <div class="row" *ngFor="let item of values.controls; let i = index" [formGroupName]="i">
              <div class="col-5" >
              <mat-form-field appearance="outline">
              <mat-label>Tax name</mat-label>
              <input matInput #input formControlName="tax_name">
              </mat-form-field>
              </div>
              
              <div class="col-6">
              <mat-form-field appearance="outline">
              <mat-label>Tax percentage</mat-label>
              <input matInput #input formControlName="tax_value" smDecimalOnly  type="number" >   
              </mat-form-field>
              </div>
              <div class="col-1">
                 <span>
                    <mat-icon style="  right: 10px;  position: relative;
                    top: 15px;
                    color: #D70D0D; cursor: pointer;
                " (click)="removeFormFieldForValues(i)">delete</mat-icon>
                 </span>
               </div>
              </div>
              
              
              <div class="add_newrt">
              <button mat-flat-button color="primary" (click)="addTaxValueField()"> <mat-icon>add</mat-icon> Add tax value</button>
              </div>
           </div>
          </form> 
          
          </div>
          <div class="cabh_sect">
            <!-- <button  mat-flat-button color="accent" class="resat-btn" >Reset</button> -->
          <button mat-flat-button color="accent" class="submit-btn" [disabled]="taxValueform.invalid" (click)="onSaveInternationalTax()">Save</button>
          </div>
          </mat-card>
          </div>
       <!-- International tax end -->
       <!-- Domestic tax start -->
       <div class="col-sm-12" *ngIf="isEntityForeign == '0'">
          <div class="lsk_cardf">
             <div>
                <mat-form-field appearance="outline">
                   <mat-label>Configuration name</mat-label>
                   <input matInput #input [(ngModel)]="taxObj.tax_name">
                  
                </mat-form-field>
             </div>
             <div>
                <mat-form-field appearance="outline">
                   <mat-label>Configuration description</mat-label>
                   <textarea matInput #input [(ngModel)]="taxObj.tax_desc"></textarea>
                  
                </mat-form-field>
             </div>
             <div class="item_list add_padding">
                <div class="item_list_data add_margin_bottom">
                   <span>GST Status</span>
                   <mat-slide-toggle (change)="onToggleChange($event)" [checked]="taxObj.gstStatus == 1"></mat-slide-toggle>
                </div>
             </div>
             <!-- <div *ngIf="taxObj.gstStatus === 1">
                <mat-form-field appearance="outline">
                   <mat-label>GST Number</mat-label>
                   <input matInput #input [(ngModel)]="taxObj.gstNumber">
                  
                </mat-form-field>
             </div> -->
             <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
               <div class="item_list_data add_margin_bottom">
                  <span>SGST</span>
                  <mat-slide-toggle (change)="onToggleChangeSGST($event)" [checked]="taxObj.sgstStatus == 1"></mat-slide-toggle>
               </div>
            </div>
            <div *ngIf="taxObj.sgstStatus === 1 && taxObj.gstStatus === 1">
               <mat-form-field appearance="outline">
                  <mat-label>SGST Rate</mat-label>
                  <input matInput #input smDecimalOnly  type="number"  [(ngModel)]="taxObj.sgstValue">
                 
               </mat-form-field>
            </div>
             <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
                <div class="item_list_data add_margin_bottom">
                   <span>CGST</span>
                   <mat-slide-toggle (change)="onToggleChangeCGST($event)" [checked]="taxObj.cgstStatus == 1"></mat-slide-toggle>
                </div>
             </div>
             <div *ngIf="taxObj.cgstStatus === 1 && taxObj.gstStatus === 1">
                <mat-form-field appearance="outline">
                   <mat-label>CGST Rate</mat-label>
                   <input matInput #input [(ngModel)]="taxObj.cgstValue" smDecimalOnly  type="number" >
                  
                </mat-form-field>
             </div>
             <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
                <div class="item_list_data add_margin_bottom">
                   <span>IGST</span>
                   <mat-slide-toggle (change)="onToggleChangeIGST($event)" [checked]="taxObj.igstStatus == 1"></mat-slide-toggle>
                </div>
             </div>
             <div *ngIf="taxObj.igstStatus === 1 && taxObj.gstStatus === 1">
                <mat-form-field appearance="outline">
                   <mat-label>IGST Rate</mat-label>
                   <input matInput #input  smDecimalOnly  type="number"  [(ngModel)]="taxObj.igstValue">
                  
                </mat-form-field>
             </div>
            
             <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
                <div class="item_list_data add_margin_bottom">
                   <span>UTGST</span>
                   <mat-slide-toggle (change)="onToggleChangeUTGST($event)" [checked]="taxObj.utgstStatus == 1"></mat-slide-toggle>
                </div>
             </div>
             <div *ngIf="taxObj.utgstStatus === 1 && taxObj.gstStatus === 1">
                <mat-form-field appearance="outline">
                   <mat-label>UTGST Rate</mat-label>
                   <input matInput #input smDecimalOnly  type="number"  [(ngModel)]="taxObj.utgstValue">
                  
                </mat-form-field>
             </div>
             <div class="item_list add_padding" >
                <div class="item_list_data add_margin_bottom">
                   <span>Service Tax</span>
                   <mat-slide-toggle (change)="onToggleChangeServiceTax($event)" [checked]="taxObj.serviceTaxStatus == 1"></mat-slide-toggle>
                </div>
             </div>
             <div *ngIf="taxObj.serviceTaxStatus === 1">
                <mat-form-field appearance="outline">
                   <mat-label>Service Tax Rate</mat-label>
                   <input matInput #input smDecimalOnly  type="number"  [(ngModel)]="taxObj.serviceTaxValue">
                  
                </mat-form-field>
             </div>
             <div class="item_list add_padding" >
                <div class="item_list_data add_margin_bottom">
                   <span>Other Tax</span>
                   <mat-slide-toggle (change)="onToggleChangeOtherTax($event)" [checked]="taxObj.otherTaxStatus == 1"></mat-slide-toggle>
                </div>
             </div>
             <div  *ngIf="taxObj.otherTaxStatus === 1">
                <mat-form-field appearance="outline">
                   <mat-label>Other Tax Name</mat-label>
                   <input matInput #input [(ngModel)]="taxObj.otherTaxName">
                  
                </mat-form-field>
             </div>
             <div *ngIf="taxObj.otherTaxStatus === 1">
                <mat-form-field appearance="outline">
                   <mat-label>Other Tax Rate</mat-label>
                   <input matInput #input smDecimalOnly  type="number"  [(ngModel)]="taxObj.otherTax">
                  
                </mat-form-field>
             </div>
             <div class="cabh_sect">
              <!-- <button  mat-flat-button color="accent" class="resat-btn" (click)="onReset()">Reset</button> -->
            <button mat-flat-button color="accent" class="submit-btn" [disabled]="
            !taxObj.tax_name
            " (click)="onSubmitTaxDetails()">Save</button>
            </div>
          </div>
       </div>
       <!-- Domestic tax end -->
    
  
  
  
       
    </div>
  </div>